import { useState } from "react";

export default function AplicationStatus() {
  const [isSmall, setIsSmall] = useState(window.innerWidth <= 900);
  return (
    <div className="aplicationStatus">
      <select
        name="application_status"
      >
	<option value="active">ԱԿՏԻՎ</option>
	<option value="null">ԲՈԼՈՐԸ</option>  
        <option value="passive">ՊԱՍԻՎ</option>
        <option value="archive">ԱՐԽԻՎ</option>
      </select>

      <select name="status">
        <option value="">{isSmall ? "ԿԱՐ-ՎԻՃ" : "ԿԱՐԳԱՎԻՃԱԿԸ"}</option>
        <option value="regular">ՌԵԳՈՒԼՅԱՐ</option>
        <option value="exclusive">ԷՔՍԿԼՅՈՒԶԻՎ</option>
        <option value="document_exclusive">ՊԱՅՄԱՆԱԳՐՈՎ ԷՔՍԿԼՅՈՒԶԻՎ</option>
      </select>
    </div>
  );
}
